<template>
    <div id="soAllocation">
        <a-modal
            title="Edit Detail"
            :visible="visible"
            width="85%"
            @cancel="() => (visible = !visible)"
        >
            <template slot="footer">
                <a-button size="small" type="primary" @click="editSave"  :disabled="packMode == 'S'">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <vxe-table
                stripe
                highlight-hover-row
                border
                resizable
                show-overflow
                ref="soAllocationTab"
                :edit-config="{trigger: 'click', mode: 'row',key: 'uid'}"
                size="mini"
                :data="tableData">
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="sku" title="SKU" minWidth="80" sortable></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="locationCode" title="Location Code" minWidth="80" sortable></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="allQty" title="Allocated Qty" minWidth="80" sortable></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="pickQty" title="Pick Qty" minWidth="80" :edit-render="{autofocus: '.vxe-input--inner'}"  sortable>
                    <template v-slot:edit="{ row }">
                        <a-input-number v-model="row.pickQty"  @change="pickQtyChange(row)" size="small" style='width: 100%;':placeholder="$t('publicLang.PleaseEnter')"/>
                    </template>
                    <template v-slot="{ row }">{{ row.pickQty }}</template>
                </vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="packageQty" title="Package Qty" minWidth="80" sortable></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="uom" title="UOM" minWidth="80" sortable></vxe-table-column>
            </vxe-table>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    export default{
        data(){
            return{
                visible: false,
                tableData: [],
                packMode: null
            }
        },
        methods:{
            show(uid){
                ajax.get(api.SOFINDQUICKEDIT,{soHeaderUid: uid}).then(res=>{
                    this.packMode = res.data.packMode
                    this.tableData = res.data.pickDetailList
                    if(this.tableData.length > 0){
                        this.visible = true
                    }else{
                        this.$customMessage.warning(this.$t('pubGicSet.NoRecordfound'));
                    }
                })
            },
            pickQtyChange(row){
                row.packageQty = row.pickQty
            },
            editSave(){
                let updateRecords = this.tableData
                let content = ''
                    for(let i in updateRecords){
                        if(updateRecords[i].pickQty < updateRecords[i].allQty){
                            content = content + updateRecords[i].sku + '/'
                        }
                    }
                    let that = this
                  if( content != ''){
                    this.$customConfirm({
                        title: 'Below Item(s) is/are short pick, do you want to process?',
                        content: content,
                        okText: 'Confirm',
                        okType: 'confirm',
                        cancelText: 'Cancel',
                        onOk() {
                            ajax.post(api.SOSAVEQUICKEDIT,{quickEditVos : that.tableData}).then(res=>{
                                if(res.code == 200){
                                    that.visible = false
                                    that.$emit('cancelImport','init')
                                }else{
                                    that.$customMessage.warning(res.msg);
                                }
                            })
                        },
                    });
                }else{
                      ajax.post(api.SOSAVEQUICKEDIT,{quickEditVos : this.tableData}).then(res=>{
                          if(res.code == 200){
                              that.visible = false
                              that.$emit('cancelImport','init')
                          }else{
                              that.$customMessage.warning(res.msg);
                          }
                      })
                }
            }
        }
    }
</script>